import { useQuery, UseQueryResult } from 'react-query';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

function useFlowDynamicTemplateVariables(
  trigger?: string | null | undefined,
): UseQueryResult<{ data: string }> {
  const params = { trigger: '' };
  if (trigger) {
    params.trigger = trigger;
  }
  return useQuery(
    ['flowDynamicTemplateVariables', trigger],
    () => client.get(`flows/dynamic-template-variables?${encodeUrlParams(params)}`),
    { enabled: !!trigger },
  );
}

export default useFlowDynamicTemplateVariables;
